import React from 'react';

const RouterContexttext = React.createContext({});

export default RouterContexttext;
